import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { CashDetailSelector, setAccount, setCashCurrency, setCashDetails, setClosingBalance, setDateFrom, setDateTo, setShowCashDetailModal, setTriggerRefreshCashDetail } from './reducers/CashDetailReducer';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import CashApi, { SearchCashParam } from './api/CashApi';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import CashModel from './models/CashModel';
import CustomModal from '../CustomModal/CustomModal';
import { Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import StartEndDatepicker from '../StartEndDatepicker/StartEndDatepicker';
import Api from '../../app/apiRequest';
import { setSelectedCashId } from './reducers/CashInputReducer';
import CashInput from './CashInput';
import CustomAccordion from '../CustomAccordion/CustomAccordion';

const CashDetailModal: React.FunctionComponent = () => {
    let dispatch = useDispatch();
    const CashDetailData = useSelector(CashDetailSelector);

    useEffect(() => {
        if (CashDetailData.triggerRefreshCashDetail > 0) {
            dispatch(showLoading(true));
            CashApi.Search({
                query: CashDetailData.query
            } as SearchCashParam).then((response: BaseResponse<CashModel[]>) => {
                if (response.success) {
                    dispatch(setCashDetails(response.data));

                    let currency = response.data.length > 0 ? response.data[0].account : "";
                    dispatch(setCashCurrency(currency));

                    dispatch(showLoading(false));

                    dispatch(setTriggerRefreshCashDetail(0));
                } else {
                    Utility.Alert.Error(response.message);
                    dispatch(showLoading(false));
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
                dispatch(showLoading(false));
            })
        }
    }, [CashDetailData.triggerRefreshCashDetail]);

    const renderTable = () => {
        let balance = CashDetailData.cashDetails[0].receipt;

        return _.map(CashDetailData.cashDetails, (cash, index) => {
            balance += cash.receipt;
            balance -= cash.payment;

            if (index == CashDetailData.cashDetails.length - 1) {
                dispatch(setClosingBalance(balance));
            }

            if (index == 0) {
                return <TableRow>
                    <TableCell></TableCell>
                    <TableCell><b>Opening Balance</b></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell><b>{CashDetailData.cashCurrency === "VND" ? Utility.NumberFormat.formatVND(cash.receipt) : Utility.NumberFormat.formatUSD(cash.receipt)}</b></TableCell>
                </TableRow>
            } else {
                return <TableRow onClick={() => {
                    dispatch(setSelectedCashId(cash.id));
                }}>
                    <TableCell>{Utility.DateFormat.formatDDMMMYYhhssString(cash.updatedDate)}</TableCell>
                    <TableCell>{cash.description}</TableCell>
                    <TableCell>{CashDetailData.cashCurrency === "VND" ? Utility.NumberFormat.formatVND(cash.receipt) : Utility.NumberFormat.formatUSD(cash.receipt)}</TableCell>
                    <TableCell>{CashDetailData.cashCurrency === "VND" ? Utility.NumberFormat.formatVND(cash.payment) : Utility.NumberFormat.formatUSD(cash.payment)}</TableCell>
                    <TableCell>{CashDetailData.cashCurrency === "VND" ? Utility.NumberFormat.formatVND(balance) : Utility.NumberFormat.formatUSD(balance)}</TableCell>
                </TableRow>
            }
        })
    }

    return <>
        <CustomModal
            open={CashDetailData.showCashDetailModal}
            onClose={() => {
                dispatch(setShowCashDetailModal(false));
            }}
            className='cash-account-modal'
        >
            <CustomAccordion
                title="Search"
                defaultOpen={true}
                className="top-quick-input"
                disableHideButton={true}
            >
                <Grid container>
                    <Grid item lg={3} xs={12}>
                        <TextField
                            className='cargo-input-component'
                            fullWidth
                            label="Account"
                            value={CashDetailData.query.account}
                            onChange={(event) => {
                                dispatch(setAccount(event.target.value));
                            }}
                        >
                        </TextField>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <StartEndDatepicker
                            startDateLabel="Date From"
                            endDateLabel="Date To"
                            className="fixture-search-item"
                            useQuickEndDateInput={false}
                            onStartDateChange={(date: string) => {
                                dispatch(setDateFrom(date));
                            }}
                            onEndDateChange={(date: string) => {
                                dispatch(setDateTo(date));
                            }}
                            startDateValue={CashDetailData.query.dateFrom}
                            endDateValue={CashDetailData.query.dateTo}
                            allowFreeInput={true}
                        >
                        </StartEndDatepicker>
                    </Grid>
                    <Grid item lg={3} xs={12}>
                        <Button
                            fullWidth
                            variant="contained"
                            className="tonnage-search-save-button"
                            onClick={() => {
                                dispatch(setTriggerRefreshCashDetail((new Date()).getTime()));
                            }}
                        >
                            RUN SEARCH (w)
                        </Button>
                    </Grid>
                </Grid>
            </CustomAccordion>
            <CashInput></CashInput>
            <Grid
                container
                justifyContent="flex-end"
                className="table-search-result-utility-bar"
            >
                <Button
                    color="secondary"
                    variant='outlined'
                    className='table-search-result-utility-bar-item'
                    onClick={() => {
                        let url = Api.constructGetUrl("/api/Cash/ExportExcel", CashDetailData.query);

                        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                        if (newWindow) newWindow.opener = null
                    }}
                >Export Excel</Button>
            </Grid>
            <Grid>
                <Table className="datatable cash-table">
                    <TableHead>
                        <TableRow className="datatable-head">
                            <TableCell rowSpan={2}>Date</TableCell>
                            <TableCell rowSpan={2}>Description</TableCell>
                            <TableCell colSpan={3} className='table-text-center'>Amount</TableCell>
                        </TableRow>
                        <TableRow className="datatable-head">
                            <TableCell>Receipt</TableCell>
                            <TableCell>Payment</TableCell>
                            <TableCell>Balance</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            CashDetailData.cashDetails.length > 0 &&
                            <>
                                {renderTable()}
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell><b>Closing Balance</b></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell><b>{CashDetailData.cashCurrency === "VND" ? Utility.NumberFormat.formatVND(CashDetailData.closingBalance) : Utility.NumberFormat.formatUSD(CashDetailData.closingBalance)}</b></TableCell>
                                </TableRow>
                            </>
                        }
                    </TableBody>
                </Table>
            </Grid>
        </CustomModal >
    </>
};

export default CashDetailModal;